<template>
  <router-view />
</template>

<script>
export default {
  name: 'UbicationTechAssistanceWrapper',
  beforeRouteEnter(_, from, next) {
    next(($this) => {
      if (from.fullPath !== '/') {
        $this.$store.dispatch('ubication-tech-assistance-mngmt/resetAll');
      }
    });
  },
  beforeRouteLeave(_, __, next) {
    next(($this) => {
      $this.$store.dispatch('ubication-tech-assistance-mngmt/resetAll');
    });
  },
};
</script>
